import { useQuery } from '@tanstack/react-query';
import { booksellerEntitlementConfigsService } from '../api/booksellerEntitlementConfigsService';

export function useBooksellerEntitlementConfig(booksellerId: string | null) {
  return useQuery({
    queryKey: ['manage-bookseller-entitlement-config', booksellerId],
    queryFn: () => booksellerEntitlementConfigsService.getFirstByBooksellerId(booksellerId!),
    enabled: !!booksellerId,
    staleTime: 30_000,
  });
}
